// extracted by mini-css-extract-plugin
export default {"card":"QuickSettingCard_card__4O9uM","textStack":"QuickSettingCard_textStack__C8OGT","status":"QuickSettingCard_status__Oi7z4","control":"QuickSettingCard_control__ur1RM"};